<template>
  <div>
    <v-select
        outlined
        dense
        v-model="selectedNode.settings.signal"
        :items="breakMethods"
        @change="(val) => onUpdate(val, 'settings.signal')"
        item-text="label"
        label="Break Method"
        style="margin-bottom: 15px"
    ></v-select>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters: workflowDetailsGetters } =
    createNamespacedHelpers("workflows/details");

export default {
  name: "breakpoint-settings",
  computed: {
    ...workflowDetailsGetters({
      selectedNode: "SELECTED_NODE",
    }),
  },
  data() {
    return {
      breakMethods: [
        {
          value: 'STOP',
          label: 'STOP'
        },
        {
          value: 'PAUSE',
          label: 'PAUSE',
        }
      ]
    }
  },
  methods: {
    onUpdate(value, path) {
      this.$emit("update", value, path);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
